import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LNGS } from '../supportedLngs.js';
import './SiteFooter.css';

function lngPrefixFromParams(lng) {
  return lng && SUPPORTED_LNGS.includes(lng) ? `/${lng}` : '';
}

export default function SiteFooter({ nearbyLinks = null }) {
  const { t } = useTranslation();
  const { lng } = useParams();
  const prefix = lngPrefixFromParams(lng);
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner container">
        {nearbyLinks && (
          <div className="site-footer__nearby">{nearbyLinks}</div>
        )}

        <nav className="site-footer__nav" aria-label={t('footer.navLabel')}>
          <Link className="site-footer__link" to={`${prefix}/about`}>{t('footer.about')}</Link>
          <Link className="site-footer__link" to={`${prefix}/privacy`}>{t('footer.privacy')}</Link>
          <Link className="site-footer__link" to={`${prefix}/terms`}>{t('footer.terms')}</Link>
          <a className="site-footer__link" href="/sitemap.xml">{t('footer.sitemap')}</a>
        </nav>

        <p className="site-footer__tagline">{t('footer.tagline')}</p>
        <p className="site-footer__legal">{t('footer.disclaimer')}</p>
        <p className="site-footer__copy">
          {t('footer.copyright', { year })}
        </p>
      </div>
    </footer>
  );
}
